import { TargetStatus } from '../../services/modules/target/target.types';
import { CanEditItemsParams } from './target.types';

export class TargetEditability {
  private static readonly UNDER_CONSTRUCTION_STATUSES = [
    TargetStatus.SUGGESTED,
    TargetStatus.DRAFT,
  ];

  static canEditItems({ status, hasUpdateAbility }: CanEditItemsParams): boolean {
    return TargetEditability.isUnderConstruction(status) && hasUpdateAbility;
  }

  static isUnderConstruction(status: TargetStatus): boolean {
    return TargetEditability.UNDER_CONSTRUCTION_STATUSES.includes(status);
  }
}
